// Getter
export const GETTER_EXIST_CUSTOMER_IDENTIFY = "GETTER_EXIST_CUSTOMER_IDENTIFY";
export const GETTER_LIST_CREDIT_CARDS = "GETTER_LIST_CREDIT_CARDS";

// action
export const ACTION_GENERATE_CUSTOMER_IDENTIFY =
  "ACTION_GENERATE_CUSTOMER_IDENTIFY";
export const ACTION_GET_EXIST_CUSTOMER_IDENTIFY =
  "ACTION_GET_EXIST_CUSTOMER_IDENTIFY";
export const ACTION_GET_LIST_CREDIT_CARDS = "ACTION_GET_LIST_CREDIT_CARDS";
export const ACTION_CREATE_CREDIT_CARD = "ACTION_CREATE_CREDIT_CARD";
export const ACTION_ADD_FUND = "ACTION_ADD_FUND";
export const ACTION_UPDATE_THRESHOLD = "ACTION_UPDATE_THRESHOLD";

// mutation
export const MUTATION_SET_EXIST_CUSTOMER_IDENTIFY =
  "MUTATION_SET_EXIST_CUSTOMER_IDENTIFY";
export const MUTATION_SET_LIST_CREDIT_CARDS = "MUTATION_SET_LIST_CREDIT_CARDS";



// WEBPACK FOOTER //
// ./src/store/modules/client_rewards_setting/constants.js